module.exports = __webpack_public_path__ + "img/2015_S.2ee2b925.png";